import { Typography, TypographyProps } from '@mui/material'

export type MolsonTypographyProps = TypographyProps & {
  dataTestId?: string
}

export const MolsonTypography = ({
  dataTestId,
  children,
  ...props
}: MolsonTypographyProps) => {
  return (
    <Typography data-testid={dataTestId} {...props}>
      {children}
    </Typography>
  )
}
